import mergeObj from '../extraUtil/mergeTwoObj';
let chart = {
        "yaxisname": "Avg Delay (Hrs)",
        "xaxisname": "Region",
        "palettecolors":"#70AE6E",
        "zeroplanecolor":"#dcdcdc",
        "zeroplanethickness": "1",
        "zeroplanealpha": "100",
        "yAxisNamePadding":"20"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
    chart = mergeObj(chart, theme);
    let dataSource = {},
        regions = [],
        data = [],
        regionsObj = {},
        regionsObjCount = {};
    for (let i = 0; i < rawData.length; i++) {
        let region = rawData[i]['destinationStateGroup'];
        if (!regions.includes(region)) {
            regions.push(region);
        }
    }
    for (let i = 0; i < regions.length; i++) {
        regionsObj[regions[i]] = 0;
        regionsObjCount[regions[i]] = 0;
    }
    for (let i = 0; i < rawData.length; i++) {
        let region = rawData[i]['destinationStateGroup'];
        rawData[i]['shipmentDelay'] && (regionsObj[region] += parseFloat(rawData[i]['shipmentDelay']));
        regionsObjCount[region] ++;
    }
    for (let index = 0; index < regions.length; index++) {
        let value = regionsObj[regions[index]]/regionsObjCount[regions[index]],
        label = String(regions[index]).toUpperCase();
        let dataObj = {
            "label": label,
            "value": value,
            "tooltext": label + ", " + value.toFixed(2) + " Hrs",
            "color": (value > 1) ? "#FF4B44" : ''
        }
        data.push(dataObj);
    }
    dataSource = {
        chart: chart,
        data: data,
        "trendlines": [
            {
                "line": [
                    {
                        "startvalue": "1",
                        "istrendzone": "0",
                        "valueonright": "0",
                        "color": "#909BAD",
                        "tooltext": "Acceptence Line of Delay",
                        "showontop": "0",
                        "thickness": "2"
                    }
                ]
            }
        ]
    }
    return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/avgShipmentDelay.js